import pl from './pl.json';

export default { pl };
